export const TURNSTILE_SITE_KEY =
  import.meta.env.REACT_APP_TURNSTILE_SITE_KEY ||
  (typeof process !== "undefined"
    ? process.env.REACT_APP_TURNSTILE_SITE_KEY
    : "") ||
  "";

export const isTurnstileEnabled = () => Boolean(TURNSTILE_SITE_KEY);
